import * as React from 'react'
import { Text, Colors, Spacing, StackChildren } from '@doordash/design-language'
import Button from '@doordash/component-button'
import Separator from '@doordash/component-separator'
import { loadUrl } from '../../../webview'

import t from './strings'

const OFFER_LETTER_URL =
  'https://cdn.doordash.com/media/dasher/offer-letter.pdf'

type OfferLetterProps = {
  showSeparator?: boolean
}
export const OfferLetter: React.FC<OfferLetterProps> = ({ showSeparator }) => (
  <React.Fragment>
    {showSeparator && (
      <Separator
        verticalMargin={Spacing.Small}
        type={Separator.Types.FullBorder}
      />
    )}
    <StackChildren size={StackChildren.Sizes.Small}>
      <Text styles={Text.Styles.Bold16}>{t.CAofferTitle()}</Text>
      <Button
        type={Button.Types.FlatPrimary}
        href={OFFER_LETTER_URL}
        target="_blank"
        tag="a"
        padding={Button.Padding.None}
        isInline={true}
        size={Button.Sizes.Small}
        onClick={() => loadUrl(OFFER_LETTER_URL)}
      >
        {t.CAofferLink()}
      </Button>
      <Text color={Colors.TextSecondary} styles={Text.Styles.Medium14}>
        {t.CAofferLegal()}
      </Text>
    </StackChildren>
  </React.Fragment>
)

OfferLetter.defaultProps = {
  showSeparator: false,
}

export default OfferLetter
